import React, { useState, useEffect } from 'react';
import { db } from '../../firebaseConfig'; 
import OneProduct from './oneProduct';
import { collection, getDocs } from 'firebase/firestore';
import { Box, Container, Typography } from '@mui/material';

const Store = () => {
  const [products, setProducts] = useState([]); 

  useEffect(() => {
    // Fetch data from the "store" collection in Firestore
    const fetchProducts = async () => {
      const querySnapshot = await getDocs(collection(db, "store"));
      const productsData = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })); // Include doc.id for unique key
      setProducts(productsData);
    };
    fetchProducts();
  }, []);

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" align="center" gutterBottom>
        Our Product Store
      </Typography>
      <Box display="flex" gap={3}  flexWrap="wrap" justifyContent="center">
        {products.map(product => (
          <OneProduct key={product.id} product={product} />
        ))}
      </Box>
    </Container>
  );
};

export default Store;
